module.exports = __webpack_public_path__ + "static/media/FLM.20254460.svg";